import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Dropdown, Modal, Badge } from 'react-bootstrap'
import Card from '../../../components/Card'
import { Link, useNavigate } from 'react-router-dom'
import { apiHandler } from '../../../api/apihandler';
import {
   NOTIFICATION_DELETE,
   NOTIFICATION_LIST,
   NOTIFICATION_READ,
   CHILD_REGISTRATION_VIEW,
   TEACHERS_ALLERGY_VIEW_API,
   TEACHERS_LUNCH_PLAN_WAIVER_API,
   TEACHERS_PEANUT_POLICY_API,
   EMERGENCY_CONTACTS_LIST,
   DAILY_REPORT_VIEW,
   LEAVE_APPLICATION_API
} from '../../../api/constants';
import Moment from 'moment';
import Swal from 'sweetalert2'
import LoaderModal from '../../../components/loaderModal';
import RegistrationDetailModal from '../../../components/registrationPacket/RegistrationDetailModal';
import { InView } from "react-intersection-observer";

// Redux Selector / Action
import { useDispatch, useSelector } from 'react-redux';

// img
import user1 from '../../../assets/images/user/01.jpg'
import user2 from '../../../assets/images/user/02.jpg'
import user3 from '../../../assets/images/user/03.jpg'
import user4 from '../../../assets/images/user/04.jpg'
import user5 from '../../../assets/images/user/05.jpg'
import user6 from '../../../assets/images/user/06.jpg'
import user7 from '../../../assets/images/user/07.jpg'
import user8 from '../../../assets/images/user/08.jpg'
import user9 from '../../../assets/images/user/09.jpg'
import user10 from '../../../assets/images/user/10.jpg'
import user11 from '../../../assets/images/user/11.jpg'
import user12 from '../../../assets/images/user/12.jpg'
import user13 from '../../../assets/images/user/13.jpg'
import user14 from '../../../assets/images/user/14.jpg'
import loader from '../../../assets/images/page-img/page-load-loader.gif'
import NoDataFound from '../../../components/noDataFound';

const Notification = () => {
   let profileData = (useSelector((state) => state.setting.setting.user_data))
   profileData = profileData ? JSON.parse(profileData) : "";
   const navigate = useNavigate();
   const [notificationlist, setNotificationList] = useState([]);
   const [page, setPage] = useState(1);
   const [maxPage, setMaxPage] = useState(1);
   const [showLoader, setShowLoader] = useState(false);
   const [showMoreDataLoader, setShowMoreDataLoader] = useState(false);
   const [showRegistrationModal, setShowRegistrationModal] = useState(false);
   const [registrationData, setRegistrationData] = useState(null);
   const [loadingRegistration, setLoadingRegistration] = useState(false);
   
   // Modal states for types 13-22
   const [showFormModal, setShowFormModal] = useState(false);
   const [formModalType, setFormModalType] = useState(null);
   const [formModalData, setFormModalData] = useState(null);

   const [isFirst, setIsFirst] = useState(true);
   useEffect(() => {
      window.scrollTo({
         top: 0,
         behavior: "smooth",
      });
      setIsFirst(false)
   }, [isFirst]);

   useEffect(() => {
      getNotificationList(1)
   }, [])

   const loadMore = (inView) => {
      if (inView) {
         if (page < maxPage) {
            getNotificationList(page + 1)
            //console.log("scroll working...", page + 1)
            setPage(page + 1)
         }
      }
   };

   function refreshApi() {
      setPage(1)
      getNotificationList(1)
   }

   async function getNotificationList(pageVal) {
      setShowMoreDataLoader(true)
      //setShowLoader(true)
      try {
         const res = await apiHandler(NOTIFICATION_LIST, "POST", {
            page: pageVal,
            limit: 10
         })
         if (res.data?.response?.status === 200) {
            setMaxPage(res?.data?.data?.notifications?.meta?.last_page)
            if (pageVal === 1) {
               setNotificationList(res?.data?.data?.notifications?.data)
            } else {
               setNotificationList(notificationlist.concat(res?.data?.data?.notifications?.data))
            }

         } else {
            //navigate('/auth/sign-in')
            //addToast(res?.response?.data?.data?.message, { appearance: 'error' });
            //console.log("profileRes",res)
         }
      } catch (error) {
         console.error(error);
      }
      finally {
         setShowMoreDataLoader(false)
         //setShowLoader(false)
      }
   }

   async function readNotification(notificationId, index, isReadVal) {
      try {
         const res = await apiHandler(NOTIFICATION_READ, "POST", {
            notification_id: notificationId
         })
         if (res.data?.response?.status === 200) {
            let temporaryarray = notificationlist.slice();
            temporaryarray[index]['is_read'] = isReadVal;
            setNotificationList(temporaryarray);
            window.dispatchEvent(new CustomEvent('notification-count-refresh', { detail: { delta: isReadVal === 1 ? -1 : 1 } }));
            // Swal.fire({
            //    title: 'Success',
            //    text: res?.response?.data?.data?.message,
            //    icon: 'success',
            //    confirmButtonText: 'Okay'
            // })
         } else {
            //navigate('/auth/sign-in')
            //addToast(res?.response?.data?.data?.message, { appearance: 'error' });
            //console.log("profileRes",res)
         }
      } catch (error) {
         console.error(error);
      }
      finally {
      }
   }

   async function deleteNotification(notificationId, isRead) {
      try {
         const res = await apiHandler(NOTIFICATION_DELETE, "DELETE", {
            notification_id: notificationId
         })
         if (res.data?.response?.status === 200) {
            // Deleting an already-read notification doesn't change the
            // unread count, so only pass a delta when the deleted item was
            // unread. The sidebar applies this immediately (instant, rather
            // than waiting on the refetch below to land) and still
            // reconciles with the server via the refetch afterward.
            window.dispatchEvent(new CustomEvent('notification-count-refresh', { detail: { delta: isRead === 1 ? 0 : -1 } }));
            refreshApi()
            // Swal.fire({
            //    title: 'Success',
            //    text: res?.response?.data?.data?.message,
            //    icon: 'success',
            //    confirmButtonText: 'Okay'
            // })
         } else {
            //navigate('/auth/sign-in')
            //addToast(res?.response?.data?.data?.message, { appearance: 'error' });
            //console.log("profileRes",res)
         }
      } catch (error) {
         console.error(error);
      }
      finally {
      }
   }

   async function fetchRegistrationDetail(studentId) {
      setLoadingRegistration(true);
      setShowRegistrationModal(true);
      try {
         const res = await apiHandler(CHILD_REGISTRATION_VIEW, "POST", {
            student_id: studentId
         });
         
         if (res.data?.response?.status === 200) {
            const apiData = res.data?.data?.data || res.data?.data || {};
            const userDetails = apiData.user_details || {};
            const registrationPackage = apiData.registration_package || {};
            
            const flattenedData = {
               ...registrationPackage,
               user_details: userDetails,
               child_first_name: userDetails.first_name || registrationPackage.child_first_name,
               child_last_name: userDetails.last_name || registrationPackage.child_last_name,
               child_date_of_birth: userDetails.date_of_birth || registrationPackage.child_date_of_birth || registrationPackage.child_dob
            };
            
            setRegistrationData(flattenedData);
         }
      } catch (error) {
         console.error('Error fetching registration detail:', error);
         setShowRegistrationModal(false);
      } finally {
         setLoadingRegistration(false);
      }
   }

   function idsEqual(left, right) {
      if (left === null || left === undefined || right === null || right === undefined) return false;
      return String(left) === String(right);
   }

   function getCollectionFromResponse(data, keys = []) {
      for (const key of keys) {
         const value = data?.[key];
         if (Array.isArray(value)) return value;
         if (Array.isArray(value?.data)) return value.data;
      }

      if (Array.isArray(data?.data)) return data.data;
      if (Array.isArray(data?.data?.data)) return data.data.data;

      return [];
   }

   function getFallbackRouteForForm(formType, formId) {
      switch (formType) {
         case 'allergy':
            return '/dashboard/allergy-action-plan/list';
         case 'lunch':
            return '/dashboard/lunch-plan-waiver/list';
         case 'peanut':
            return '/dashboard/no-peanut-policy/list';
         case 'emergency':
            return '/dashboard/emergency-contact/list';
         case 'dailyReport':
            if (profileData?.user_type === 4) return '/dashboard/daily-reports';
            return '/dashboard/app/profile';
         case 'leave':
            return '/dashboard/app/leave-application';
         default:
            return '/pages/home';
      }
   }

   async function fetchFormDetail(formType, formId, userId) {
      const fallbackRoute = getFallbackRouteForForm(formType, formId);
      const resolvedUserId = userId || profileData?.id || null;

      // If we don't have a usable user context, skip modal fetch and open the target screen.
      if (!resolvedUserId) {
         setShowFormModal(false);
         setFormModalType(null);
         setFormModalData(null);
         navigate(fallbackRoute);
         return;
      }

      setShowFormModal(true);
      setFormModalType(formType);
      setFormModalData(null); // Set to null initially to show loading
      
      try {
         let endpoint = null;
         let payload = { student_id: resolvedUserId };
         
         switch(formType) {
            case 'allergy':
               endpoint = TEACHERS_ALLERGY_VIEW_API;
               payload = { student_id: resolvedUserId };
               break;
            case 'lunch':
               endpoint = TEACHERS_LUNCH_PLAN_WAIVER_API;
               payload = { student_id: resolvedUserId };
               break;
            case 'peanut':
               endpoint = TEACHERS_PEANUT_POLICY_API;
               payload = { student_id: resolvedUserId };
               break;
            case 'emergency':
               endpoint = EMERGENCY_CONTACTS_LIST;
               payload = { page: 1, limit: 100, student_id: resolvedUserId };
               break;
            case 'dailyReport':
               endpoint = DAILY_REPORT_VIEW;
               payload = { report_id: formId, student_id: resolvedUserId };
               break;
            case 'leave':
               endpoint = LEAVE_APPLICATION_API;
               payload = { page: 1, limit: 100, student_id: resolvedUserId };
               break;
            default:
               setShowFormModal(false);
               setFormModalType(null);
               setFormModalData(null);
               navigate(fallbackRoute);
               return;
         }
         
         console.log('Fetching form detail:', { formType, formId, userId, endpoint, payload });
         const res = await apiHandler(endpoint, "POST", payload);
         console.log('API Response:', res.data);
         
         if (res.data?.response?.status === 200) {
            let formData = null;
            
            // Extract the specific record based on formId
            if (formType === 'emergency') {
               const contacts = getCollectionFromResponse(res.data?.data, ['emergency_contacts', 'contacts']);
               formData = contacts.find(contact => idsEqual(contact?.id, formId)) || contacts[0];
            } else if (formType === 'leave') {
               const leaves = getCollectionFromResponse(res.data?.data, ['leave_applications', 'leaves']);
               formData = leaves.find(leave => idsEqual(leave?.id, formId)) || leaves[0];
            } else if (formType === 'dailyReport') {
               formData = res.data?.data?.report || res.data?.data?.daily_report || res.data?.data;
            } else if (formType === 'allergy') {
               const rawData = res.data?.data;
               if (rawData?.student && (rawData?.allergy_action_plan || rawData?.allergy_report)) {
                  const allergyData = rawData.allergy_action_plan || rawData.allergy_report;
                  formData = {
                     ...allergyData,
                     student_name: rawData.student?.name,
                     child_name: rawData.student?.name,
                     student_email: rawData.student?.email,
                     student_photo: rawData.student?.photo,
                     // Map allergy report fields
                     allergies: allergyData?.symptoms || allergyData?.allergies || allergyData?.allergy_type,
                     allergy_type: allergyData?.symptoms || allergyData?.allergy_type,
                     severity: allergyData?.require_epi_pen ? 'severe' : 'moderate',
                     reaction: allergyData?.symptoms || allergyData?.allergic_reaction || allergyData?.reaction,
                     treatment: allergyData?.emergency_treatment_procedures || allergyData?.emergency_treatment || allergyData?.treatment,
                     notes: allergyData?.location_of_epi_pen || allergyData?.notes,
                     signature: allergyData?.parent_signature || allergyData?.signature,
                     signed_date: allergyData?.parent_signature_date || allergyData?.signed_date
                  };
               } else {
                  formData = res.data?.data?.allergy_action_plan || res.data?.data?.allergy_report || res.data?.data?.allergy || res.data?.data;
               }
            } else if (formType === 'lunch') {
               const rawData = res.data?.data;
               if (rawData?.student && rawData?.lunch_plan_waiver) {
                  formData = {
                     ...rawData.lunch_plan_waiver,
                     student_name: rawData.student?.name,
                     child_name: rawData.student?.name,
                     student_email: rawData.student?.email,
                     student_photo: rawData.student?.photo
                  };
               } else {
                  formData = res.data?.data?.lunch_plan_waiver || res.data?.data?.lunch_plan || res.data?.data;
               }
            } else if (formType === 'peanut') {
               // Try multiple possible data structures
               const rawData = res.data?.data;
               if (rawData?.student && rawData?.policy) {
                  // Merge student and policy data
                  formData = {
                     ...rawData.policy,
                     student_name: rawData.student?.name,
                     student_email: rawData.student?.email,
                     student_photo: rawData.student?.photo,
                     child_name: rawData.student?.name,
                     signature: rawData.policy?.parent_signature,
                     signed_date: rawData.policy?.parent_signature_date,
                     date_signed: rawData.policy?.parent_signature_date,
                     acknowledged: rawData.policy?.status === 1 || rawData.policy?.status === true,
                     parent_name: rawData.policy?.parent_name || 'N/A',
                     has_peanut_allergy: rawData.policy?.has_peanut_allergy || false
                  };
               } else {
                  formData = res.data?.data?.peanut_policy || 
                            res.data?.data?.policy || 
                            res.data?.data?.no_peanut_policy ||
                            res.data?.data?.peanutPolicy ||
                            res.data?.data;
               }
               // If data is nested in an array, get the first item
               if (Array.isArray(formData)) {
                  formData = formData[0] || formData;
               }
            } else {
               formData = res.data?.data || {};
            }
            
            console.log('Extracted form data:', formData);
            
            if (!formData || (Array.isArray(formData) && formData.length === 0)) {
               Swal.fire({
                  icon: 'info',
                  title: 'No Data',
                  text: 'No form details found for this notification.'
               });
               setShowFormModal(false);
               navigate(fallbackRoute);
               return;
            }
            
            setFormModalData(formData);
         } else {
            setShowFormModal(false);
            setFormModalType(null);
            setFormModalData(null);
            navigate(fallbackRoute);
         }
      } catch (error) {
         console.error('Error fetching form detail:', error);
         setShowFormModal(false);
         setFormModalType(null);
         setFormModalData(null);
         navigate(fallbackRoute);
      }
   }

   function generateURL(elm) {
      const type = Number(elm?.type);
      const feedType = Number(elm?.feed_type);
      const valueId = elm?.value_id || elm?.valueId || elm?.form_id || elm?.id || null;
      const userId = elm?.user_id || elm?.student_id || elm?.user?.id || profileData?.id || null;
      const friendSlug = elm?.value_slug || elm?.user?.slug || elm?.value_id;
      let dynaMicURL = null
      
      // Notification Types:
      // 0: Follow, 1: Comment, 2: Participate, 3: Dance corner post, 4: Challenge post
      // 5: Winner, 6: Like, 7: Tag, 8: Hire, 10: Event, 11: Class
      // 12: Form submission, 13: Illness report, 14: Accident report
      // 15: Allergy action plan, 16: Lunch plan waiver, 17: No peanut policy
      // 18: Emergency contact, 19: Daily report published, 20: Medication administered
      // 21: Leave application, 22: Non-medication administered, 40: Billing statement
      
      switch (type) {
         case 0: // Follow (Follow Request)
            dynaMicURL = `/dashboard/app/friend-request`
            break
         case 1: // Comment
            if (feedType === 0) {
               dynaMicURL = valueId ? `/pages/recipe/${valueId}` : `/pages/home`
            } else {
               dynaMicURL = valueId ? `/dashboard/app/challengeDetails/${valueId}` : `/pages/home`
            }
            break
         case 2: // Participate
            dynaMicURL = valueId ? `/dashboard/app/challengeDetails/${valueId}` : `/pages/home`
            break
         case 3: // Dance corner post
            dynaMicURL = valueId ? `/dashboard/app/challengeDetails/${valueId}` : `/pages/home`
            break
         case 4: // Challenge post
            dynaMicURL = valueId ? `/dashboard/app/challengeDetails/${valueId}` : `/pages/home`
            break
         case 5: // Winner
            dynaMicURL = valueId ? `/dashboard/app/challengeDetails/${valueId}` : `/pages/home`
            break
         case 6: // Like
            if (feedType === 0) {
               dynaMicURL = valueId ? `/pages/recipe/${valueId}` : `/pages/home`
            } else {
               dynaMicURL = valueId ? `/dashboard/app/challengeDetails/${valueId}` : `/pages/home`
            }
            break
         case 7: // Tag
            if (feedType === 0) {
               dynaMicURL = valueId ? `/pages/recipe/${valueId}` : `/pages/home`
            } else {
               dynaMicURL = valueId ? `/dashboard/app/challengeDetails/${valueId}` : `/pages/home`
            }
            break
         case 8: // Hire
            dynaMicURL = friendSlug ? `/dashboard/app/friend-profile/${friendSlug}` : `/pages/home`
            break
         case 10: // Event
            dynaMicURL = `/pages/home`
            break
         case 11: // Class
            dynaMicURL = `/pages/home`
            break
         case 12: // Form submission (Registration Package)
            if (userId) {
               fetchRegistrationDetail(userId);
            } else {
               dynaMicURL = '/dashboard/child-registration/list';
            }
            break
         case 13: // Illness report
         case 14: // Accident report
            dynaMicURL = `/pages/home`
            break
         case 15: // Allergy action plan
               fetchFormDetail('allergy', valueId, userId);
               return;
            break
         case 16: // Lunch plan waiver
               fetchFormDetail('lunch', valueId, userId);
               return;
            break
         case 17: // No peanut policy
               fetchFormDetail('peanut', valueId, userId);
               return;
            break
         case 18: // Emergency contact
               fetchFormDetail('emergency', valueId, userId);
               return;
            break
         case 19: // Daily report published
               dynaMicURL = getFallbackRouteForForm('dailyReport', valueId);
            break
         case 20: // Medication administered
         case 22: // Non-medication administered
            dynaMicURL = `/pages/home`
            break
         case 21: // Leave application
               fetchFormDetail('leave', valueId, userId);
               return;
            break
         case 40: // Billing statement
            dynaMicURL = '/dashboard/app/profile'
            break
         default:
            // Fallback for unknown types
            if (feedType === 0 && valueId) {
               dynaMicURL = `/pages/recipe/${valueId}`
            } else {
               dynaMicURL = `/pages/home`
            }
            break
      }
      
      if (dynaMicURL) {
         navigate(dynaMicURL)
      }
   }

   return (
      <>
         <LoaderModal showLoader={showLoader} />
         <div id='content-page' className='content-page'>
            <Container>
               <Row>
                  <Col sm="12">
                     <h4 className="card-title mb-3">Notification</h4>
                  </Col>
                  <Col sm="12">
                     {
                        notificationlist.length > 0 ?
                           <div>
                              {
                                 notificationlist.map((elm, i) => (
                                    <Link to="#"//to={generateURL(elm)} //onClick={() => readNotification(elm?.id, i, 1)}
                                    >
                                       {
                                          elm?.is_read === 1 ?
                                             <Card className="card_read_background_color">
                                                <Card.Body >
                                                   <ul className="notification-list m-0 p-0">
                                                      <li className="d-flex ">
                                                         <div className="user-img img-fluid"
                                                            onClick={() => {
                                                               navigate(profileData?.user_type === 4 ? "#" : `/dashboard/app/friend-profile/${elm?.user?.slug}`)
                                                            }}>
                                                            <img src={elm?.user?.user_setting?.photo ?
                                                               elm?.user?.user_setting?.photo :
                                                               "https://uzone360live.s3.amazonaws.com/noimage.png"}
                                                               alt="story-img" className="rounded-circle avatar-40" />
                                                         </div>
                                                         <div style={{ width: "97%" }}
                                                            onClick={() => {
                                                               //readNotification(elm?.id, i, 1)
                                                               generateURL(elm)
                                                            }}>
                                                            <div className=" ms-3">
                                                               <h6>{elm?.description}</h6>
                                                               <p className="mb-0">{Moment(elm?.created_at).format('MMM D YYYY')}</p>
                                                            </div>
                                                         </div>
                                                         <div style={{ width: "3%" }}>
                                                            <div className="d-flex " style={{ alignItems: "right" }}>
                                                               <div className="d-flex align-items-center">
                                                                  <div className="card-header-toolbar d-flex align-items-center">
                                                                     <Dropdown>
                                                                        <Link to="#">
                                                                           <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                                              more_horiz
                                                                           </Dropdown.Toggle>
                                                                        </Link>
                                                                        <Dropdown.Menu className="dropdown-menu-right">
                                                                           {
                                                                              elm?.is_read === 1 ?
                                                                                 <Dropdown.Item to="#" onClick={() => readNotification(elm?.id, i, 0)}><i className="ri-eye-off-fill me-2"></i>Mark as unread</Dropdown.Item> :
                                                                                 <Dropdown.Item to="#" onClick={() => readNotification(elm?.id, i, 1)}><i className="ri-eye-fill me-2"></i>Mark as read</Dropdown.Item>
                                                                           }
                                                                           <Dropdown.Item to="#" onClick={() => deleteNotification(elm?.id, elm?.is_read)}><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                                        </Dropdown.Menu>
                                                                     </Dropdown>
                                                                  </div>
                                                               </div>
                                                            </div>
                                                         </div>
                                                      </li>
                                                   </ul>
                                                </Card.Body>
                                             </Card> :
                                             <Card>
                                                <Card.Body >
                                                   <ul className="notification-list m-0 p-0">
                                                      <li className="d-flex ">
                                                         <div className="user-img img-fluid"
                                                            onClick={() => {
                                                               navigate(profileData?.user_type === 4 ? "#" : `/dashboard/app/friend-profile/${elm?.user?.slug}`)
                                                            }}>
                                                            <img src={elm?.user?.user_setting?.photo ?
                                                               elm?.user?.user_setting?.photo :
                                                               "https://uzone360live.s3.amazonaws.com/noimage.png"}
                                                               alt="story-img" className="rounded-circle avatar-40" />
                                                         </div>
                                                         <div style={{ width: "97%" }}
                                                            onClick={() => {
                                                               readNotification(elm?.id, i, 1)
                                                               generateURL(elm)
                                                            }}>
                                                            <div className=" ms-3">
                                                               <h6>{elm?.description}</h6>
                                                               <p className="mb-0">{Moment(elm?.created_at).format('MMM D YYYY')}</p>
                                                            </div>
                                                         </div>
                                                         <div style={{ width: "3%" }}>
                                                            <div className="d-flex " style={{ alignItems: "right" }}>
                                                               <div className="d-flex align-items-center">
                                                                  <div className="card-header-toolbar d-flex align-items-center">
                                                                     <Dropdown>
                                                                        <Link to="#">
                                                                           <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                                              more_horiz
                                                                           </Dropdown.Toggle>
                                                                        </Link>
                                                                        <Dropdown.Menu className="dropdown-menu-right">
                                                                           {
                                                                              elm?.is_read === 1 ?
                                                                                 <Dropdown.Item to="#" onClick={() => readNotification(elm?.id, i, 0)}><i className="ri-eye-off-fill me-2"></i>Mark as unread</Dropdown.Item> :
                                                                                 <Dropdown.Item to="#" onClick={() => readNotification(elm?.id, i, 1)}><i className="ri-eye-fill me-2"></i>Mark as read</Dropdown.Item>
                                                                           }
                                                                           <Dropdown.Item to="#" onClick={() => deleteNotification(elm?.id, elm?.is_read)}><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                                        </Dropdown.Menu>
                                                                     </Dropdown>
                                                                  </div>
                                                               </div>
                                                            </div>
                                                         </div>
                                                      </li>
                                                   </ul>
                                                </Card.Body>
                                             </Card>
                                       }
                                    </Link>
                                 ))
                              }
                              <InView as="div" onChange={(inView, entry) => loadMore(inView)} />
                           </div> : <NoDataFound />
                     }

                     {
                        showMoreDataLoader ?
                           <div className="col-sm-12 text-center">
                              <img src={loader} alt="loader" style={{ height: "100px" }} />
                           </div> : null
                     }
                     {/* <InView as="div" onChange={(inView, entry) => loadMore(inView)} /> */}

                     {/* <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user2} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className=" ms-3">
                                          <h6>Anne Fibbiyon Like Your Post</h6>
                                          <p className="mb-0">15  ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-danger rounded">
                                             <i className="material-symbols-outlined md-18">
                                                favorite_border
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card>
                     <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user3} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className="ms-3">
                                          <h6>Barry Cuda add Story</h6>
                                          <p className="mb-0">40  ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-primary rounded">
                                             <i className="material-symbols-outlined md-18">
                                                military_tech
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card>
                     <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user4} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className="ms-3">
                                          <h6>Cliff Hanger posted a comment on your status update</h6>
                                          <p className="mb-0">42  ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-success rounded">
                                             <i className="material-symbols-outlined md-16">
                                                chat_bubble_outline
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card>
                     <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user4} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className="ms-3">
                                          <h6>Rick O'Shea posted a comment on your photo</h6>
                                          <p className="mb-0">50  ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-success rounded">
                                             <i className="material-symbols-outlined md-16">
                                                chat_bubble_outline
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card>
                     <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user5} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className="ms-3">
                                          <h6>Brock Lee Sent a Friend Request</h6>
                                          <p className="mb-0">1 hour ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-warning rounded">
                                             <i className="material-symbols-outlined md-18">
                                                reply
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card>
                     <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user6} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className=" ms-3">
                                          <h6>Ira Membrit shared your status update</h6>
                                          <p className="mb-0">1 hour ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-info rounded">
                                             <i className="material-symbols-outlined md-18">
                                                share
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card>
                     <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user11} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className="ms-3">
                                          <h6>Paul Molive and 3 ther have Birthday Today</h6>
                                          <p className="mb-0">3 houe ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-danger rounded">
                                             <i className="material-symbols-outlined md-18">
                                                cake
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card>
                     <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user7} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className="ms-3">
                                          <h6>Petey Cruiser Sent a Friend request</h6>
                                          <p className="mb-0">1 day ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-warning rounded">
                                             <i className="material-symbols-outlined md-18">
                                                reply
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card>
                     <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user8} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className="ms-3">
                                          <h6>Bob Frapples and 45 other Like Your Pst on timeline</h6>
                                          <p className="mb-0">1 week ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-danger rounded">
                                             <i className="material-symbols-outlined md-18">
                                                favorite_border
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card>
                     <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user12} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className="ms-3">
                                          <h6>Maya Didas share Your Post</h6>
                                          <p className="mb-0">1 month ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-info rounded">
                                             <i className="material-symbols-outlined md-18">
                                                share
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card>
                     <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user9} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className=" ms-3">
                                          <h6>Sal Monella Add Photo with You</h6>
                                          <p className="mb-0">1 month ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-primary rounded">
                                             <i className="material-symbols-outlined md-18">
                                                military_tech
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card>
                     <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user10} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className="ms-3">
                                          <h6>Barb Dwyer commented on your new profile status</h6>
                                          <p className="mb-0">2 month ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-success rounded">
                                             <i className="material-symbols-outlined md-16">
                                                chat_bubble_outline
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card>
                     <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user13} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className="info ms-3">
                                          <h6>Terry Aki commented on your new profile status</h6>
                                          <p className="mb-0">2 month ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-success rounded">
                                             <i className="material-symbols-outlined md-16">
                                                chat_bubble_outline
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card>
                     <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user14} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className=" ms-3">
                                          <h6>Paige Turner Posted in Development Community</h6>
                                          <p className="mb-0">3 month ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-primary rounded">
                                             <i className="material-symbols-outlined md-18 ">
                                                military_tech
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card> */}
                  </Col>
               </Row>
            </Container>
         </div>

         {/* Registration Detail Modal for Teachers */}
         <RegistrationDetailModal
            show={showRegistrationModal}
            onHide={() => {
               setShowRegistrationModal(false);
               setRegistrationData(null);
            }}
            data={registrationData}
            loading={loadingRegistration}
            showEditButton={false}
         />

         {/* Generic Form Detail Modal for Types 13-22 */}
         <Modal 
            show={showFormModal} 
            onHide={() => {
               setShowFormModal(false);
               setFormModalType(null);
               setFormModalData(null);
            }}
            size="lg"
            centered
         >
            <Modal.Header closeButton>
               <Modal.Title>
                  {formModalType === 'allergy' && 'Allergy Action Plan'}
                  {formModalType === 'lunch' && 'Lunch Plan Waiver'}
                  {formModalType === 'peanut' && 'No Peanut Policy'}
                  {formModalType === 'emergency' && 'Emergency Contact'}
                  {formModalType === 'dailyReport' && 'Daily Report'}
                  {formModalType === 'leave' && 'Leave Application'}
               </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{
               padding: '0',
               maxHeight: 'calc(80vh - 120px)',
               overflowY: 'auto',
               background: '#f8fafc'
            }}>
               {!formModalData ? (
                  <div className="text-center p-4" style={{ background: 'white' }}>
                     <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                     </div>
                     <p className="mt-3">Loading form details...</p>
                  </div>
               ) : (
                  <div style={{ padding: '20px' }}>
                     {/* Emergency Contact */}
                     {formModalType === 'emergency' && formModalData && (
                        <div style={{
                           background: 'white',
                           borderRadius: '12px',
                           padding: '20px',
                           boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                           border: '1px solid #e5e7eb'
                        }}>
                           <Row className="mb-3">
                              <Col xs={12} sm={6} className="mb-3 mb-sm-0">
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Name</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.name || formModalData.contact_name || 'N/A'}</div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Relationship</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.relationship || 'N/A'}</div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Phone</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.phone || formModalData.phone_number || 'N/A'}</div>
                                 </div>
                              </Col>
                              <Col xs={12} sm={6}>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Email</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529', wordBreak: 'break-word' }}>{formModalData.email || 'N/A'}</div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Address</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.address || 'N/A'}</div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Authorized for Pickup</div>
                                    <Badge bg={formModalData.can_pick_up ? 'success' : 'secondary'}>{formModalData.can_pick_up ? 'Yes' : 'No'}</Badge>
                                 </div>
                              </Col>
                           </Row>
                        </div>
                     )}
                     
                     {/* Leave Application */}
                     {formModalType === 'leave' && formModalData && (
                        <div style={{
                           background: 'white',
                           borderRadius: '12px',
                           padding: '20px',
                           boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                           border: '1px solid #e5e7eb'
                        }}>
                           <Row className="mb-3">
                              <Col xs={12} sm={6} className="mb-3 mb-sm-0">
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Student Name</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.student_name || 'N/A'}</div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Leave Type</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.leave_type || 'N/A'}</div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>From Date</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.from_date ? Moment(formModalData.from_date).format('MMM D, YYYY') : 'N/A'}</div>
                                 </div>
                              </Col>
                              <Col xs={12} sm={6}>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>To Date</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.to_date ? Moment(formModalData.to_date).format('MMM D, YYYY') : 'N/A'}</div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Status</div>
                                    <Badge bg={formModalData.status === 'approved' ? 'success' : formModalData.status === 'rejected' ? 'danger' : 'warning'}>{formModalData.status || 'Pending'}</Badge>
                                 </div>
                              </Col>
                           </Row>
                           <Row>
                              <Col xs={12}>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Reason</div>
                                    <div style={{ fontSize: '14px', color: '#495057', padding: '12px', background: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                                       {formModalData.reason || 'N/A'}
                                    </div>
                                 </div>
                              </Col>
                           </Row>
                        </div>
                     )}
                     
                     {/* Allergy, Lunch, Peanut, Medication, Non-Medication, Daily Report */}
                     {formModalType === 'allergy' && formModalData && (
                        <div style={{
                           background: 'white',
                           borderRadius: '12px',
                           padding: '20px',
                           boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                           border: '1px solid #e5e7eb'
                        }}>
                           <Row className="mb-3">
                              <Col xs={12} sm={6} className="mb-3 mb-sm-0">
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Student Name</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                                       {formModalData.student_name || formModalData.child_name || formModalData.user?.first_name || 'N/A'}
                                    </div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Symptoms/Allergies</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                                       {formModalData.allergies || formModalData.symptoms || formModalData.allergy_type || formModalData.allergy_name || 'N/A'}
                                    </div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Severity</div>
                                    <Badge bg={formModalData.severity === 'severe' ? 'danger' : formModalData.severity === 'moderate' ? 'warning' : 'info'}>{formModalData.severity || 'Moderate'}</Badge>
                                 </div>
                                 {formModalData.require_epi_pen !== undefined && (
                                    <div style={{ marginBottom: '16px' }}>
                                       <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Requires EpiPen</div>
                                       <Badge bg={formModalData.require_epi_pen ? 'danger' : 'secondary'}>{formModalData.require_epi_pen ? 'Yes' : 'No'}</Badge>
                                    </div>
                                 )}
                              </Col>
                              <Col xs={12} sm={6}>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Emergency Treatment</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                                       {formModalData.treatment || formModalData.emergency_treatment_procedures || formModalData.emergency_treatment || 'N/A'}
                                    </div>
                                 </div>
                                 {formModalData.location_of_epi_pen && (
                                    <div style={{ marginBottom: '16px' }}>
                                       <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>EpiPen Location</div>
                                       <div style={{ fontSize: '14px', fontWeight: '600', color: '#d32f2f' }}>{formModalData.location_of_epi_pen}</div>
                                    </div>
                                 )}
                                 {formModalData.signature && (
                                    <div style={{ marginBottom: '16px' }}>
                                       <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '8px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Parent Signature</div>
                                       <img 
                                          src={formModalData.signature} 
                                          alt="Parent Signature" 
                                          style={{
                                             maxWidth: '100%', 
                                             width: '200px', 
                                             border: '1px solid #ddd', 
                                             padding: '5px', 
                                             borderRadius: '8px'
                                          }} 
                                          onError={(e) => { 
                                             e.target.style.display = 'none'; 
                                             e.target.parentElement.innerHTML += `<div style="fontSize: 14px; fontWeight: 600; color: #212529;">${formModalData.signature}</div>`;
                                          }}
                                       />
                                    </div>
                                 )}
                                 {formModalData.signed_date && (
                                    <div style={{ marginBottom: '16px' }}>
                                       <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Signed Date</div>
                                       <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                                          {Moment(formModalData.signed_date).format('MMM D, YYYY')}
                                       </div>
                                    </div>
                                 )}
                              </Col>
                           </Row>
                           {(formModalData.notes || formModalData.additional_information) && (
                              <Row>
                                 <Col xs={12}>
                                    <div style={{ marginBottom: '16px' }}>
                                       <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Additional Information</div>
                                       <div style={{ fontSize: '14px', color: '#495057', padding: '12px', background: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                                          {formModalData.notes || formModalData.additional_information}
                                       </div>
                                    </div>
                                 </Col>
                              </Row>
                           )}
                        </div>
                     )}

                     {formModalType === 'lunch' && formModalData && (
                        <div style={{
                           background: 'white',
                           borderRadius: '12px',
                           padding: '20px',
                           boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                           border: '1px solid #e5e7eb'
                        }}>
                           <Row className="mb-3">
                              <Col xs={12} sm={6} className="mb-3 mb-sm-0">
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Student Name</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                                       {formModalData.student_name || formModalData.child_name || formModalData.user?.first_name || 'N/A'}
                                    </div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Waiver Type</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                                       {formModalData.waiver_type || formModalData.lunch_type || formModalData.type || 'N/A'}
                                    </div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Status</div>
                                    <Badge bg={formModalData.status === 'approved' ? 'success' : formModalData.status === 'rejected' ? 'danger' : 'warning'}>{formModalData.status || 'Pending'}</Badge>
                                 </div>
                              </Col>
                              <Col xs={12} sm={6}>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Effective Date</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.effective_date ? Moment(formModalData.effective_date).format('MMM D, YYYY') : 'N/A'}</div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Parent/Guardian</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.parent_name || formModalData.guardian_name || 'N/A'}</div>
                                 </div>
                              </Col>
                           </Row>
                           {formModalData.reason && (
                              <Row>
                                 <Col xs={12}>
                                    <div style={{ marginBottom: '16px' }}>
                                       <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Reason</div>
                                       <div style={{ fontSize: '14px', color: '#495057', padding: '12px', background: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                                          {formModalData.reason}
                                       </div>
                                    </div>
                                 </Col>
                              </Row>
                           )}
                        </div>
                     )}

                     {formModalType === 'peanut' && formModalData && (
                        <div style={{
                           background: 'white',
                           borderRadius: '12px',
                           padding: '20px',
                           boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                           border: '1px solid #e5e7eb'
                        }}>
                           <Row className="mb-3">
                              <Col xs={12} sm={6} className="mb-3 mb-sm-0">
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Student Name</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                                       {formModalData.student_name || formModalData.child_name || formModalData.user?.first_name || 'N/A'}
                                    </div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Policy Acknowledged</div>
                                    <Badge bg={(formModalData.acknowledged || formModalData.is_acknowledged || formModalData.policy_acknowledged) ? 'success' : 'danger'}>
                                       {(formModalData.acknowledged || formModalData.is_acknowledged || formModalData.policy_acknowledged) ? 'Yes' : 'No'}
                                    </Badge>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Date Signed</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                                       {(formModalData.signed_date || formModalData.date_signed || formModalData.signature_date || formModalData.created_at) ? 
                                          Moment(formModalData.signed_date || formModalData.date_signed || formModalData.signature_date || formModalData.created_at).format('MMM D, YYYY') : 'N/A'}
                                    </div>
                                 </div>
                              </Col>
                              <Col xs={12} sm={6}>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Parent Name</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                                       {formModalData.parent_name || formModalData.guardian_name || formModalData.parent_guardian_name || 'N/A'}
                                    </div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Has Peanut Allergy</div>
                                    <Badge bg={(formModalData.has_peanut_allergy || formModalData.has_allergy || formModalData.peanut_allergy) ? 'warning' : 'secondary'}>
                                       {(formModalData.has_peanut_allergy || formModalData.has_allergy || formModalData.peanut_allergy) ? 'Yes' : 'No'}
                                    </Badge>
                                 </div>
                              </Col>
                           </Row>
                           {(formModalData.signature || formModalData.parent_signature || formModalData.guardian_signature) && (
                              <Row className="mt-3">
                                 <Col xs={12}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '8px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Parent Signature</div>
                                    <img src={formModalData.signature || formModalData.parent_signature || formModalData.guardian_signature} alt="Parent Signature" style={{maxWidth: '100%', width: '200px', border: '1px solid #ddd', padding: '5px', borderRadius: '8px'}} />
                                 </Col>
                              </Row>
                           )}
                           {/* Debug info - remove after testing */}
                           {console.log('Peanut Policy Data:', formModalData)}
                        </div>
                     )}

                     {formModalType === 'dailyReport' && formModalData && (
                        <div style={{
                           background: 'white',
                           borderRadius: '12px',
                           padding: '20px',
                           boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                           border: '1px solid #e5e7eb'
                        }}>
                           <Row className="mb-3">
                              <Col xs={12}>
                                 <h6 style={{ 
                                    fontSize: '15px',
                                    fontWeight: '700',
                                    color: '#667eea',
                                    marginBottom: '20px',
                                    paddingBottom: '12px',
                                    borderBottom: '2px solid #e5e7eb'
                                 }}>
                                    Daily Report Summary
                                 </h6>
                              </Col>
                              <Col xs={12} sm={6} className="mb-3 mb-sm-0">
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Student Name</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.student_name || formModalData.child_name || 'N/A'}</div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Date</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.report_date ? Moment(formModalData.report_date).format('MMM D, YYYY') : 'N/A'}</div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Mood</div>
                                    <Badge bg="info">{formModalData.mood || 'N/A'}</Badge>
                                 </div>
                              </Col>
                              <Col xs={12} sm={6}>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Meals</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.meals || formModalData.meal_status || 'N/A'}</div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Nap Time</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.nap_time || formModalData.sleep_duration || 'N/A'}</div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Bathroom</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.bathroom || formModalData.diaper_changes || 'N/A'}</div>
                                 </div>
                              </Col>
                           </Row>
                           {formModalData.activities && (
                              <Row className="mb-3">
                                 <Col xs={12}>
                                    <div style={{ marginBottom: '16px' }}>
                                       <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Activities</div>
                                       <div style={{ fontSize: '14px', color: '#495057', padding: '12px', background: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                                          {formModalData.activities}
                                       </div>
                                    </div>
                                 </Col>
                              </Row>
                           )}
                           {formModalData.notes && (
                              <Row>
                                 <Col xs={12}>
                                    <div style={{ marginBottom: '16px' }}>
                                       <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Teacher Notes</div>
                                       <div style={{ fontSize: '14px', color: '#495057', padding: '12px', background: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                                          {formModalData.notes}
                                       </div>
                                    </div>
                                 </Col>
                              </Row>
                           )}
                        </div>
                     )}
                  </div>
               )}
            </Modal.Body>
            <Modal.Footer>
               <button 
                  className="btn btn-secondary" 
                  onClick={() => {
                     setShowFormModal(false);
                     setFormModalType(null);
                     setFormModalData(null);
                  }}
               >
                  Close
               </button>
            </Modal.Footer>
         </Modal>
      </>
   )
}

export default Notification